<script setup lang="ts">
import { DisplayTick } from '..';
import DateComp from '../Basic/DateComp.vue';

const props = defineProps<{
    /**
     * The date value to display
     */
    value: Date | null;
}>();
</script>

<template>
    <div class="d-flex flex-row flex-nowrap gap-3">
        <DisplayTick :value="value != null" />
        <DateComp
            :value="value"
            format="DATETIMESHORT"
        />
    </div>
</template>
